import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncate',
  standalone: true
})
export class TruncatePipe implements PipeTransform {
  transform(value: string, limit: number = 20, trail: string = '...'): string {
    if (!value) return ''; // Handle null or undefined values
    return value.length > limit ? value.substring(0, limit) + trail : value;
  }
}